<template>
  <div class="contentBox" :class="device=='mobile'?'mobileBox':''">
    <web ref="web" class="webBox"></web>
    <p class="title">选择训练营</p>
    <div class="banner">
      <div class="banner-item clear" v-for="(item,index) in accountObj.list" :key="index" :class="((index+1)%2==1?'odd':'dual')" @click="trainingSub(item.rmid)">
        <img :src="'https://pic.bi-rong.com/'+item.image" class="slide-image"  alt="轮播图"/>
      </div>
    </div>
     <!-- <div class="swiper-container">
      <swiper
        @slideChange="onSlideChange"
        :autoHeight="true"
        :options="swiperOptions"
        ref="mySwiper"
      >
        <!-- 轮播项 -->
        <!-- <swiper-slide v-for="(item, index) in accountObj.list" :key="index" @click.stop="trainingSub(item)">
          <img :src="'https://pic.bi-rong.com/'+item.image" class="slide-image" alt="轮播图" :data-id="item.rmid" />
        </swiper-slide> -->

        <!-- 分页器 -->
        <!-- <div class="swiper-pagination" slot="pagination"></div> -->

        <!-- 导航按钮 -->
        <!-- <div class="swiper-button-prev" slot="button-prev"></div> -->
        <!-- <div class="swiper-button-next" slot="button-next"></div> -->
      <!-- </swiper> -->
    <!-- </div> -->
    <div class="userData">
      <div class="account" @click="identityShow">账号:{{accountObj.mobile}}</div>
      <div class="identity" v-if="identityType">
        <div class="identity-item parent" :class="accountObj.login_type==2?'select':''" @click="identitySub(2)"></div>
        <div class="identity-item student" :class="accountObj.login_type==1?'select':''" @click="identitySub(1)"></div>
        <button class="btn btn-sub" @click="loginOut">退出登录</button>
      </div>
    </div>
  </div>
</template>
<script>
import { indexData , switchUsers ,logoutStudent} from "@/assets/js/api";
import web from './../components/comment/web.vue';
export default {
  name: "login",
  data() {
    return {
      token:'',
      accountObj:{},
      identityType:false,
      device:'',
      // Swiper 配置项
      swiperOptions: {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: false,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        on: {
          click: (e) =>  {
              var id = e.target.getAttribute('data-id')
              this.trainingSub(id)
            console.log(id,'id');
            console.log(this.$refs.mySwiper.$swiper.activeIndex)
          }
        },
        preventClicks: false, // 允许点击事件传递到子元素
        preventClicksPropagation: false // 允许点击事件在子元素上触发
      },
    };
  },
  components: {
    web
  },
  mounted(){
    document.title = '选择训练营';
    var userData = JSON.parse(localStorage.getItem('identityData'));
    this.token = userData.apiToken;
    this.getDetail();
    this.device = this.$refs.web.device;
    if(this.device == 'mobile'){
      this.$refs.web.font_resize();
    };
  },
  methods: {
    identitySub(e){
      this.accountObj.login_type = e;
      this.identityChange();
    },

    onSlideChange() {
      const activeIndex = this.$refs.mySwiper.$swiper.activeIndex; // 获取当前激活的幻灯片索引
      console.log('Active slide index:', activeIndex);
      // 在这里处理切换事件，例如更新状态或执行其他逻辑。
    },

    trainingSub(id){
      if(this.accountObj.login_type == 2){
        this.$router.push('/result?rmid='+id);
        return false;
      }
      this.$router.push('/identityList?rmid='+id)
    },

    async getDetail(){
      var that = this;
      try {
        const response = await indexData(this.token);
        if(response.code == 200){
          that.accountObj = response.data;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    identityShow(){
      this.identityType = !this.identityType
    },

    async identityChange(){
      var that = this;
      try {
        const response = await switchUsers({login_type:this.accountObj.login_type},this.token);
        if(response.code == 200){
          that.accountObj = response.data;
          localStorage.removeItem('identityData');
          localStorage.setItem('identityData',JSON.stringify(response.data))
          window.location.reload()
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async loginOut(){
      var that = this;
      try {
        const response = await logoutStudent(this.token);
        if(response.code == 200){
          localStorage.removeItem('identityData');
          that.$router.push('/identityLogin')
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    }
  },

  
};
</script>
<style scoped>
  .contentBox{
    background-image: url(~@/assets/images/index-bg.png);
    width: 100%;
    height: 100%;
    background-size: 100% 100%;
    padding: 101px 0 75px;
  }

  .title{
    color: #333333;
    font-size: 65px;
    display: block;
    font-weight: bold;
    text-align: center;
  }

  .banner{
    height: 70%;
    display: block;
    margin:  60px auto 0;
    font-size: 0;
    text-align: center;
    overflow-y: auto;
  }

  .banner .banner-item{
    width: calc( 100% / 2 - 30px );
    height: 304px;
    display: inline-block;
    vertical-align: top;
    margin: 15px;
    overflow: hidden;
  }

  .banner .banner-item img{
    display: block;
    width: 548px;
    height: 100%;
    margin: 0 auto;
    border-radius: 20px;
  }

  .banner .banner-item.odd{
    float: left;
  }
  .banner .banner-item.odd img{
    float: right;
  }
  .banner .banner-item.dual{
    float: right;
  }
  .banner .banner-item.dual img{
    float: left;
  }

  .userData{
    position: fixed;
    top: 40px;
    right: 60px;
  }

  .account{
    background-image: url(~@/assets/images/icon-bg1.png);
    width: 261px;
    height: 56px;
    background-size: 261px 56px;
    margin-bottom: 20px;
    font-size: 20px;
    line-height: 56px;
    color: #fff;
    text-align: center;
  }

  .identity{
    background-color: #fff;
    border-radius: 18px;
    box-sizing: border-box;
    padding: 30px;
    position: absolute;
    top: 80px;
    right: 0;
  }

  .identity-item{
    background-image: url(~@/assets/images/identity-parent.png);
    width: 289px;
    height: 116px;
    background-size: 289px 116px;
  }

  .identity-item.parent.select{
    background-image: url(~@/assets/images/icon-bg2.png);
  }

  .identity-item.student{
    background-image: url(~@/assets/images/identity-student.png);
  }

  .identity-item.student.select{
    background-image: url(~@/assets/images/icon-bg3.png);
  }

  .identity .btn-sub{
    padding: 8px 40px;
    box-sizing: border-box;
    font-size: 20px;
    color: #fff;
    border-radius: 60px;
    background-color: #1B1B1B;
    display: block;
    margin: 20px auto 0;
  }

  /* .swiper-container {
    width: 844px;
    max-width: 100%;
    height: 474px;
    margin: 0 auto;
  }

  .slide-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  } */
</style>



// WEBPACK FOOTER //
// src/identity/index.vue